<template>
  <!-- <section
    id="chat"
    :key="this.$route.params.merchant_id"
    class="chat-window">
    <div class="chat-window-box">
      <Conversations
        ref="Conversations"
        @conversationChanged="changeConversation"
        @folderActivityChanged="checkFolderChangingAbility"
        @folderChanged="changeActiveFolder"
        @assignmentFolderChanged="changeAssignmentFolder"/>
      <Messages
        ref="Messages"
        :conversationp="currentConversation"                                     // now available in the vuex
        :folderp="folder"                                                        // now available in the vuex
        :assignmentp="assignment"/>                                              // now available in the vuex
      <UserInfo :conversationp="currentConversation"/>
    </div>
  </section> -->
  <section
    id="chat">
    <Inbox/>
    <Conversations
      ref="Conversations"
      @conversationChanged="changeConversation"/>
    <Messages/>
    <!-- <div style="">Messages</div> -->
    <transition
      name="user-details">
      <!-- <keep-alive> -->
      <UserDetails
        v-if="userDetailsSectionShown"
        :section="userDetailsSectionShown"
        :conversation="currentConversation"/>
      <!-- </keep-alive> -->
    </transition>
    <UserActions/>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import '@/assets/css/modules/_chat.scss';
import ChatEventBus from './ChatEventBus';
import UserDetails from './partials/UserDetails';
import UserActions from './partials/UserActions';
import Inbox from './Inbox';
import Conversations from './Conversations';
import Messages from './Messages';
// import UserInfo from './UserInfo';

export default {
  name: 'Chat',
  components: {
    Inbox,
    Conversations,
    Messages,
    // UserInfo,
    UserDetails,
    UserActions,
  },
  data() {
    return {
      currentConversation: {},
      folder: 'open',
      assignment: 'all',
      userDetailsSectionShown: null,
    };
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters({
      currentOrganisationBusinessIds: 'organisation/currentOrganisationBusinessIds',
    }),
  },
  created() {
    this.clearChatData();
  },
  mounted() {
    // this.fetchMembers(this.$route.params.merchant_id); // handled by organisation component

    window.addEventListener('blur', this.onBlur);
    window.addEventListener('focus', this.onFocus);

    // this.subscribeToPusherChat(this.currentOrganisationBusinessIds);

    ChatEventBus.$on('showUserDetails', (section) => {
      this.userDetailsSectionShown = section;
    });
  },
  beforeDestroy() {
    this.clearChatData();
    this.$eventBus.$off('contactDataChanged');

    window.removeEventListener('blur', this.onBlur);
    window.removeEventListener('focus', this.onFocus);

    // this.unsubscribeFromPusherChat(this.currentOrganisationBusinessIds);
  },
  methods: {
    ...mapActions({
      clearChatData: 'chat/clearChatData',
      // fetchMembers: 'merchant/fetchMembers', // handled by organisation component
      // subscribeToPusherChat: 'pusher/subscribeToPusherChat',
      // unsubscribeFromPusherChat: 'pusher/unsubscribeFromPusherChat',
    }),
    onBlur() {
      // this.unsubscribeFromPusherChat(this.currentOrganisationBusinessIds);
    },
    onFocus() {
      // this.subscribeToPusherChat(this.currentOrganisationBusinessIds);
    },
    checkFolderChangingAbility() {
      this.$refs.Messages.detectFolderChangingAbility();
    },
    changeConversation(conversation) {
      if (conversation) {
        this.currentConversation = conversation;
        this.$nextTick(() => {
          this.$refs.Messages.detectFolderChangingAbility();
        });
      } else {
        this.currentConversation = {};
      }
    },
    changeActiveFolder(folder) {
      this.folder = folder;
    },
    changeAssignmentFolder(assignment) {
      this.assignment = assignment;
    },
  },
};
</script>

<style lang="scss" scoped>
#chat {
  display: flex;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.user-details-enter {
  width: 0px!important
}

.user-details-leave-to {
  width: 0px!important;
}
</style>